import {useRef, useState} from 'react'
import {useNavigate} from 'react-router'
import {useDrag} from 'react-ui-animate'
import {Button} from 'brand/Button'
import {LogoPlus} from 'brand/LogoPlus'
import {Pager} from 'brand/Pager'

const introSlides = [
  {
    title: () => 'Snap a selfie to begin...',
    body: () => (<>
      <strong>Take a photo of yourself</strong>, answer some
      questions about you, your skin, your style, and aspirations
      to get 3 personalised looks and product recommendations.
    </>),
    bgClass: 'green-gold',
    headingSize: 'size-xxxl',
  }, {
    title: () => (<><em>Learn</em> professional techniques</>),
    body: () => (<>
      <strong>Learn how to create perfect looks</strong> that suit you,
      and gain confidence to experiment, in easy to follow steps.
    </>),
    bgClass: 'red-lipstick-hand',
    headingSize: 'size-xxxl',
  }, {
    title: () => 'Find the best products for your skin & your looks',
    body: () => (<>
      My Beauty PA can curate a virtual beauty bag with advice and
      shopping links to your favourite and alternative recommended
      products – including cruelty-free and ethical choices.
    </>),
    bgClass: 'lip-gloss-shoulder',
    headingSize: 'size-xxl',
  },
]
const afterSlides = '/consult'

const swipeThreshold = 96

export const Intro = () => {
  const nav = useNavigate()
  const swiperRef = useRef(null)
  const [dragging, setDragging] = useState(false)
  const draggingClass = dragging ? 'dragging' : ''
  const [slide, setSlide] = useState(0)
  const slideContent = introSlides[slide]

  const updateSlideNumber = num => {
    setSlide(num)
    swiperRef.current?.style?.setProperty('--slide-number', num)
  }

  const prevSlide = () => {
    if (slide > 0) {
      updateSlideNumber(slide - 1)
    }
  }
  const nextSlide = ({fromSwipe = false}) => {
    if (slide < introSlides.length - 1) {
      updateSlideNumber(slide + 1)
    } else if (!fromSwipe) {
      nav(afterSlides)
    }
  }

  const bind = useDrag(({down, movementX}) => {
    if (down && !dragging) { // begin drag
      setDragging(true)
    }
    if (dragging && !down) { // end drag
      if (movementX > swipeThreshold) {
        prevSlide()
      } else if (movementX < -swipeThreshold) {
        nextSlide({fromSwipe: true})
      }
      setDragging(false)
    }
    swiperRef.current?.style?.setProperty('--x', `${movementX}px`)
  })

  return (
    <div className="fullscreen-avoiding-chrome column">
      <div className="intro-top-container">
        <div className={`intro-top ${draggingClass}`} ref={swiperRef}>
          {introSlides.map(({bgClass, title: Title, headingSize}) => (
            <div className={`slide ${bgClass}`} key={bgClass}>
              <div className="shade" />
              <div className="float-cover">
                <section className="app-setup">
                  <div><LogoPlus /></div>
                  <div className={`heading ${headingSize}`}><Title /></div>
                </section>
              </div>
            </div>
          ))}
        </div>
        <div className="float-cover" style={{flexDirection: 'column'}}>
          <div style={{display: 'flex'}}>
            <Pager count={introSlides.length} current={slide} skipTo={afterSlides} />
          </div>
          <div style={{flexGrow: 1}} {...bind()}/>
        </div>
      </div>
      <div className="intro-bottom">
        <section className="app-setup">
          <div className="size-ml line-l"><slideContent.body /></div>
          <Button size="large" action={nextSlide}>Next</Button>
        </section>
      </div>
    </div>
  )
}
